import React from 'react';
import PropTypes from 'prop-types';
import NotificationMethods from '../../../../../common/notificationMethods';
import withCanModifyBarber from './withCanModifyBarber';

const Notifications = ({ canModify, formSectionName, minInterval, edit }) => (
  <div className="u-mv u-ml">
    <fieldset disabled={!canModify}>
      <NotificationMethods disabled={!canModify} barber formSectionName={formSectionName} minInterval={minInterval} edit={edit} />
    </fieldset>
  </div>
);

Notifications.propTypes = {
  canModify: PropTypes.bool.isRequired,
  formSectionName: PropTypes.string,
  minInterval: PropTypes.number,
  edit: PropTypes.bool,
};

Notifications.defaultProps = {
  formSectionName: null,
  minInterval: null,
  edit: false,
};

export default withCanModifyBarber(Notifications);
